var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tot)?_c('div',{staticClass:"totpanel"},[_c('span',{staticClass:"totpanel__label",domProps:{"innerHTML":_vm._s(_vm.tot.label)}}),_c('span',{staticClass:"totpanel__value"},[(_vm.isLoading)?[_c('span',{staticClass:"totpanel__value__loading"},[_c('Spinner')],1)]:[_c('span',{domProps:{"innerHTML":_vm._s(_vm.tot.value)}})]],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }